export default __webpack_public_path__ + "sm-logo-inverted.e64ad746cf695ad849f51b7b62e617dd.svg";